module.exports = __webpack_public_path__ + "static/media/designCharrette_climate_header.d22605d6.jpg";